import { Component, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material';
import { CustomTranslationDialogComponent } from '../custom-translation-dialog/custom-translation-dialog.component';
import { TranslationObj } from '@app/shared/services/custom-translation.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-custom-translation-field',
  templateUrl: './custom-translation-field.component.html',
  styleUrls: ['./custom-translation-field.component.scss']
})
export class CustomTranslationFieldComponent implements OnDestroy {
  @Input() fieldValue: string;
  @Input() locField: string;
  @Input() title: string;
  @Input() bundleNames: string[];
  @Input() notLockedValue: string;
  @Input() matField = true;

  private dialogRef: MatDialogRef<CustomTranslationDialogComponent>;
  private dialogConfig: MatDialogConfig = new MatDialogConfig();

  private componentDestroyed$ = new Subject();

  @Output() private changeValueField: EventEmitter<{ key: string; value: string }> = new EventEmitter();

  constructor(private dialog: MatDialog) {}

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.unsubscribe();
  }

  clickOnField(): void {
    this.dialogConfig.data = {
      value: this.locField ? this.locField : this.fieldValue,
      title: this.title,
      bundleNames: this.bundleNames,
      notLockedValue: this.notLockedValue
    };
    this.dialogConfig.width = '60vw';

    this.dialogRef = this.dialog.open(CustomTranslationDialogComponent, this.dialogConfig);
    this.dialogRef.afterClosed().subscribe((data: TranslationObj) => {
      if (data && data.key) {
        this.changeValueField.emit({
          key: data.key,
          value: data.translations[0].value
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/custom-translation-field/custom-translation-field.component.ts